module.exports = __webpack_public_path__ + "img/post-submit-button.99f3ab54.png";